import apiClient from 'lib/apiClient';
import axios from 'lib/apiClient';

export const listFolders = (query) =>
  apiClient.get('API/1_0/fileFolders.php', { params: query });

export const addFolder = (name, parent_id) =>
  apiClient.post('API/1_0/fileFolders.php', { folder_name: name, parent_id });

export const getFolder = (hash) =>
  apiClient
    .get('API/1_0/fileFolders.php', { params: { hash } })
    .then((resp) => resp[0]);

export const updateFolder = (values) =>
  apiClient.post('API/1_0/fileFolders.php', values);

export const deleteFolder = (hash) =>
  apiClient.delete('API/1_0/fileFolders.php', { params: { hash } });

export const listFiles = (folderId) =>
  apiClient.get('API/1_0/files.php', { params: { folder_id: folderId } });

export const getFile = (query) =>
  apiClient.get('API/1_0/files.php', { params: query }).then((r) => r[0]);

export const addFile = (folderId, file, convertAudio) => {
  const formData = new FormData();
  formData.append('media_file', file, file.name);
  if (folderId) {
    formData.append('folder_id', folderId);
  }
  if (convertAudio) {
    formData.append('convert_to_mp3', '1');
  }

  return axios.post(`API/1_0/postMedia.php`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateFile = (data) => apiClient.post('API/1_0/files.php', data);

export const deleteFile = (fileId) =>
  apiClient.delete('API/1_0/files.php', { params: { hash: fileId } });

export const fileToObject = (type, objId, fileId) => {
  return apiClient.post('API/1_0/fileToObject.php', {
    object_type: type,
    object_id: objId,
    file_id: fileId,
  });
};

export const getFilesByObject = ({ type, objId }) =>
  apiClient.get('API/1_0/fileToObject.php', {
    params: { object_type: type, object_id: objId },
  });

export const deleteFileObject = (hash) =>
  apiClient.delete('API/1_0/fileToObject.php', {
    params: { hash },
  });

export const deleteFileObjects = async (type, fileId) => {
  const f = await apiClient.get('API/1_0/fileToObject.php', {
    params: { object_type: type, file_id: fileId },
  });
  await Promise.allSettled(f.map((i) => deleteFileObject(i.hash)));
};
